import '../../css/custom-responsive.css';
import '../../css/custom.css';
import { useState, useEffect } from 'react';
import normaldot3 from '../../images/normal dot 3.png';
import normalactivedot from '../../images/active dot.png';
import License from './components/LicenseandPricingComponent';
import CloudUsage from './components/CloudUsageDistributionComponent';
import ResourceCounts from './components/ResourceCountComponent';
import ProtocolsDistribution from './components/ProtocolsDistributionComponent';
import SystemHealth from './components/SystemHealthComponent';
import AlertsWindow from './components/AlertsWindowComponent';
import Urls from '../../utils/urls';
import { prefixPath } from '../../utils/helpers';
import { subscriptionItem } from '../myAccount/subscription/subscription';
import BaseUrls from '../../utils/baseUrls';
import apiBackendInstance from '../../utils/axios';

interface cloudType {
  cloud: string,
  usage: number
}
interface props{
  theme:string
}
const DashboardBody = ({ theme }:props) => {
  const TmpData: cloudType[] = [
    { cloud: 'AWS', usage: 0 },
    { cloud: 'Digital Ocean', usage: 0 },
    { cloud: 'GCP', usage: 0 },
    { cloud: 'Tencent Cloud', usage: 0 },

  ];
  const fallBackData = {
    workspace: 0,
    networks: 0,
    nodes: 0,
    clouds: 0,
    endpoints: 0,
  };
  const [cloudUsageData, setCloudUsageData] = useState(TmpData);
  const [activeCloud, setActiveCloud] = useState(false);
  const [cloudMessage, setCloudMessage] = useState('   Loading ...');
  const [totalCost, setTotalCost] = useState(-1);
  const [nodeCount, setNodeCount] = useState(-1);
  const [resourceData, setResourceData] = useState(fallBackData);

  const getTotalCost = (data: subscriptionItem[]) => {
    let cost = 0;
    for (let i = 0; i < data.length; i += 1) {
      cost += data[i].subscription_details.amount;
    }
    return cost;
  };
  useEffect(() => {
    // const isActive = true;
    if (Urls.getEnvironment() === 'production') {
      apiBackendInstance.get(Urls.getSubscriptionSummary(), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response && response.data && response.data.data) {
          setTotalCost(getTotalCost(response.data.data));
        }
      }).catch(() => {
        setTotalCost(0);
      });
    }
    apiBackendInstance.get(Urls.getAllCloudsUsage(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data.data) {
        const dxd = response.data.data.data;
        const arr: boolean[] = [false, false, false, false];
        const dt: cloudType[] = [];
        if (dxd.length === 0) {
          setCloudMessage('No Active Node');
        }
        if (dxd.length !== 0) {
          setActiveCloud(true);
        }
        for (let i = 0; i < dxd.length; i += 1) {
          if (dxd[i].cloud) {
            if (dxd[i].cloud.toLowerCase() === 'aws') {
              arr[0] = true;
              dt.push({ cloud: 'AWS', usage: dxd[i].usage });
            }
            if (dxd[i].cloud.toLowerCase() === 'digital ocean' || dxd[i].cloud.toLowerCase() === 'digitalocean') {
              arr[1] = true;
              dt.push({ cloud: 'Digital Ocean', usage: dxd[i].usage });
            }
            if (dxd[i].cloud.toLowerCase() === 'gcp') {
              arr[2] = true;
              dt.push({ cloud: 'GCP', usage: dxd[i].usage });
            }
            if (dxd[i].cloud.toLowerCase() === 'tencent') {
              arr[3] = true;
              dt.push({ cloud: 'Tencent Cloud', usage: dxd[i].usage });
            }
          }
        }
        for (let k = 0; k < 4; k += 1) {
          if (!arr[k]) {
            switch (k) {
              case 0: dt.push({ cloud: 'AWS', usage: 0 });
                arr[k] = true;
                break;
              case 1: dt.push({ cloud: 'Digital Ocean', usage: 0 });
                arr[k] = true;
                break;
              case 2: dt.push({ cloud: 'GCP ', usage: 0 });
                arr[k] = true;
                break;
              case 3: dt.push({ cloud: 'Tencent Cloud', usage: 0 });
                arr[k] = true;
                break;
              default:
            }
          }
        }
        setCloudUsageData(dt);
      }
    }).catch((err) => {
      console.error('cloud error', err);
      setCloudUsageData(TmpData);
      setCloudMessage('Not Enough Data');
    });

    apiBackendInstance.get(Urls.getWorkSpaceStatsUrl(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data) {
        setResourceData(response.data.data);
        if (response.data.data.nodes === '0') {
          setNodeCount(0);
        } else {
          setNodeCount(1);
        }
      }
    }).catch(() => setResourceData(fallBackData));
  }, []);
  const imgSubPath = window.location.origin;
  const dashboardImg = imgSubPath + prefixPath(`/img/${theme}/img.png`);
  const absImg = imgSubPath + prefixPath(`/img/${theme}/Abstract 2.png`);
  return (
    <section className="px-5 col-12 workspace">
      <div className="row mt-5 ">
        <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-xs-12 mx-auto">
          <div className="slidercard card-protocol" style={{ backgroundImage: `url(${dashboardImg})` }}>
            <div className="mx-3 card-body">
              {nodeCount > 0
              && (
<>
              <h5 className="card-title mt-5 activeTextColor">Share Your Network to Create Ecosystems</h5>
              <p className="card-text col-xl-6 col-lg-6 col-sm-12 col-md-12 textdata">
                Invite others to be part of your network and expand your consortium.
                Make your Dapps available to your partners and scale your blockchain
                solutions in a cloud agnostic manner.
              </p>
</>
              )}
              {(nodeCount === 0)
              && <a href={BaseUrls.getPlatformDedicatedFullNodesUrl()}><h5 className="card-title mt-5 activeTextColor">Deploy Your First Node</h5></a>}
              {(nodeCount === 0)
              && (
              <p className="card-text col-xl-6 col-lg-6 col-sm-12 col-md-12 textdata">
                Deploy a node of your choice of protocol in a few clicks with your choice of infrastructure and configurations. Let Zeeve worry about what it takes to get your service up and running!.
              </p>
              )}
              <a
                href=" "
                className="btn mt-3 mb-3"
              >
                {' '}
                <img src="" alt="" />
                {' '}
              </a>
            </div>
            <div className="mx-5 d-flex">
              <div className="col-3 mb-4">
                <img className=" mx-1" src={normaldot3} alt="" style={{ display: 'none' }} />
                <img className="mx-1 mt-1" src={normalactivedot} alt="" style={{ display: 'none' }} />
                <img className="mx-1" src={normaldot3} alt="" style={{ display: 'none' }} />
                <img className="mx-1" src={normaldot3} alt="" style={{ display: 'none' }} />
              </div>
              <div className="abstract-img">
                <img src={absImg} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12">
          <div className="card zeeve-license">
            <License name={theme} cost={totalCost} />
          </div>
        </div>
      </div>
      <div className="mt-4 row gx-4">
          <div className="col-xl-5 col-lg-4 col-md-12 col-sm-12 col-xs-12">
            <CloudUsage cloudData={cloudUsageData} activeCloud={activeCloud} message={cloudMessage} />
          </div>
          <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 col-xs-12">
            <ResourceCounts theme={theme} resourceData={resourceData} />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12">
            <ProtocolsDistribution />
          </div>
      </div>
      <div className="mt-4 mb-4">
          <AlertsWindow />
      </div>
        <div className="mt-4 mb-4">
          <SystemHealth />
        </div>
    </section>

  );
};

export default DashboardBody;
